const setActiveVariant = () => {
  // Update URL with selected variant ID
  const activeVariant = document.querySelector('a.pdp-c-atc-size-selector__size-item--active');
  history.replaceState(null, null, window.location.pathname + `?variant=${activeVariant.dataset.variantId}`);

  // Update Style Number at the bottom part in "Details" tab. It is present in "Product Description Section"
  const productJson = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  const currentVariant = productJson.variants.find((variant) => variant.id === Number(activeVariant.dataset.variantId));

  if (!currentVariant) return;

  const styleNumber = document.querySelector('[data-style-number-value]');
  if (styleNumber) {
    styleNumber.textContent = currentVariant.barcode;
  }
};

export default setActiveVariant;
